import React from 'react';
import Header from '../components/Header.jsx';
import Hero from '../components/Hero.jsx';
import Benefits from '../components/Benefits.jsx';
import Problem from '../components/Problem.jsx';
import About from '../components/About.jsx';
import Testimonials from '../components/Testimonials.jsx';
import Curriculum from '../components/Curriculum.jsx';
import Pricing from '../components/Pricing.jsx';
import Guarantee from '../components/Guarantee.jsx';
import Footer from '../components/Footer.jsx';

const HomePage = () => {
  return (
    <div className="min-h-screen font-sans">
      <Header />
      <Hero />
      <Benefits />
      <Problem />
      <About />
      <Testimonials />
      <Curriculum />
      <Pricing />
      <Guarantee />
      <Footer />
    </div>
  );
};

export default HomePage;